import type { InputHTMLAttributes, ReactNode, Ref } from "react";
import { formField } from "@web/theme/theme";
import { FormField } from "./FormField";

export type TextFieldProps = Omit<InputHTMLAttributes<HTMLInputElement>, "className" | "id"> & {
  label: ReactNode;
  hint?: ReactNode;
  error?: ReactNode;
  className?: string;
  /** Text shown inside the control on the left (e.g. "$"). */
  prefix?: string;
  inputRef?: Ref<HTMLInputElement>;
};

/** Labeled native input (FormField + input): 44px tall, control radius, hairline border. Works for text/email/tel/date/time/number. */
export function TextField({ label, hint, error, className = "", prefix, inputRef, ...rest }: TextFieldProps) {
  return (
    <FormField label={label} hint={hint} error={error} className={className}>
      {(a11y) => {
        const input = <input ref={inputRef} {...a11y} className={`${formField.control} ${prefix ? formField.withPrefix : ""}`} {...rest} />;
        return prefix ? (
          <div className={formField.selectWrap}>
            <span aria-hidden className={formField.prefix}>
              {prefix}
            </span>
            {input}
          </div>
        ) : (
          input
        );
      }}
    </FormField>
  );
}
